<script setup lang="ts">
import type { TabsListProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { TabsList } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { cn } from '@/lib/utils'

const props = defineProps<TabsListProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')
</script>

<template>
  <TabsList
    :class="
      cn(
        'inline-flex h-8 items-end justify-start bg-background border-b border-border text-xs text-muted-foreground',
        props.class
      )
    "
    v-bind="delegatedProps"
  >
    <slot />
  </TabsList>
</template>

